import React from 'react';
import _ from 'lodash';
import classnames from 'classnames';
import { Button, Typography, Tag, Popover } from "antd";
import { PRODUCT_FILTER_KEYS, TICKET_SYSTEM_CONFIG_ERROR } from './constants';
import { Sorters, CellRenderers } from 'utils/tableUtils';
import { parseURLSearch } from 'utils/urlUtil';
import { getVocabulary } from 'components/Vocabulary';
import { formatNumber } from 'utils/numberUtil';

export const ShowMorePopover = (values, record, count, onClick, type, formatter, {className, style, wrapperStyle, showAllEntriesOnHover = false} = {}) => {
  if (_.isEmpty(values)) {
    return "N/A";
  }
  if (typeof values === "string") {
    values = [values];
  }
  const resorces = values.slice();
  const minResources = resorces.splice(0, count);
  let content = null;

  const isClickable = (_.isFunction(onClick) && onClick !== _.noop);

  const getItems = (r, i, source) => {
    if (type === "link") { return <Typography.Link className="m-r-sm m-b-sm" key={i} onClick={() => onClick(r, record)}>{format(r?.name || r, i,  source)}</Typography.Link> }
    if (type === "tag") { return <Tag className={classnames("tools", "m-b-xs", {clickable: isClickable}, className)} style={style} key={i} onClick={() => onClick(r, record)}><b>{format(r?.name || r, i, source)}</b></Tag> }
    const CustomTag = type || 'div';
    return <CustomTag className={classnames("m-r-sm", "m-b-sm", className)} key={i}>{format(r.name || r, i, source)}</CustomTag>;
  };

  const format = (text, i, source) => formatter ? formatter(text, i, source) : text;

  if (resorces.length) {
    content = (
      <div style={{ maxHeight: 150, maxWidth: 200, overflow: "auto" }}>
        {
          showAllEntriesOnHover ?
            values.map((v, i) => getItems(v, i, values))
            :
            resorces.map((v, i) => getItems(v, i, resorces))
        }
      </div>
    )
  }
  return (
    <div style={{...wrapperStyle}}>
      {
        minResources.map(getItems)
      }
      {
        resorces.length
          ?
          <Popover trigger="click" content={content}>
            <Button size="small" type="link" style={{ fontSize: 12 }}>+{resorces.length}</Button>
          </Popover>
          :
          null
      }
    </div>
  )
}

export function getCreateTicketTitle({ suffix, productName, subProductName, environmentName }) {
  if(!(productName || subProductName || environmentName)){
    return suffix;
  }
  let title = "";
  if(productName){
    title += `${getVocabulary("product")}: ${productName}`;

    if(subProductName){
      title += `, ${getVocabulary("subProduct")}: ${subProductName}`
    }
    if(environmentName){
      title += `, Environment: ${environmentName}`;
    }
  }

  return (title ? `${title} & ${suffix}` : suffix).substring(0, 255);
}

export const ticketInfo = ({ticketDetails, createNewTicket, systemError}) => {
  let ticket
  for(const item of ticketDetails) {
    if(item?.ticketDetailJpaDto?.ticketId) {
      ticket = item
      break;
    }
    if(item.status === "CREATE_FAILED") {
      if(!ticket) ticket = item
    } else {
      ticket = item
    }
  }
  if(ticket?.ticketDetailJpaDto?.ticketId) {
    return <Typography.Link key={ticket.ticketDetailJpaDto.ticketId} size="small" href={ticket.ticketDetailJpaDto.url} target="_blank" >{ticket.ticketDetailJpaDto.ticketId}</Typography.Link> 
  }
  switch (ticket?.status) {
    case 'TO_BE_CREATED':
      return <Typography.Text key={ticket.id} >Ticket creation is in-progress</Typography.Text>
    case "CREATE_FAILED":
    case "ERROR_OCCURRED":
      return systemError ? <Typography.Text type="danger">{TICKET_SYSTEM_CONFIG_ERROR}</Typography.Text> : createNewTicket
    default:
      return null
  }
}

export const getFoundByFromNestedStats = (nestedStats) => {
  let toolsCount = {};

  _.map(nestedStats, (value) => _.map(value.stat, (foundBy) => {
    if(foundBy.name) {
      toolsCount[foundBy.name] ? toolsCount[foundBy.name] += foundBy.count : toolsCount[foundBy.name] = foundBy.count;
    }
  }) )

  return _.map(toolsCount, (value, key) => {
    return {[key]: formatNumber(value, "short")}
  })
}

export const productFilterChanged = (search, prevSearch) => {
  const { filters } = parseURLSearch(search)
  const { filters: prevFilters } = parseURLSearch(prevSearch)
  const productFilter = _.pick(filters, PRODUCT_FILTER_KEYS);
  const prevProductFilter = _.pick(prevFilters, PRODUCT_FILTER_KEYS);
  return !_.isEqual(productFilter, prevProductFilter)
}

export const getSeverities = (severities, record, cbFunc) => {
  const _severities = _.isArray(severities) ? severities : Object.keys(severities);
  const sortedSeverities = _severities.sort(Sorters.SEVERITY(null, true));
  return (
    sortedSeverities.map((severity, i) => <span key={`${severity}_${i}`}onClick={() => _.isArray(severities) ? cbFunc(record, severity) : cbFunc(null, record, severity)}>{CellRenderers.SEVERITY(severity, "m-b-sm clickable")}</span>)
  );
}

export const getProductSubProductFilters = (search) => {
  const filterKeys = ['environmentName', 'product', 'subProduct']
  const { filters } = parseURLSearch(search)
  let _filters = {};
  _.forEach(filterKeys, (filterKey) => {
    _filters[filterKey] = filters[filterKey];
  });
  return _filters;
}

export const findingsPopoverFormatter = (value) => {
  return _.map(value, (count, name) => {
    const value = `${name} (${count})`;
    return <span title={value}>{value}</span>;
  });
}

